module.exports = __webpack_public_path__ + "img/full2-min.485ab275.png";